import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../styles/BundleDetailsPage.css';

import Products from'../../products.json';

const BundleDetailsPage = ({ cart, updateCart }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bundle, setBundle] = useState(null);

  useEffect(() => {
    // Mock data - in a real app you'd fetch this
    const mockBundles = Products.bundles;
    /* const mockBundles = [
      {
        id: 1,
        name: "Starter Bundle",
        description: "Perfect for beginners with essential items",
        price: 99.99,
        image: "https://via.placeholder.com/300x200?text=Starter+Bundle",
        details: "Includes: Basic item A, Basic item B, and Starter guide"
      },
      {
        id: 2,
        name: "Premium Bundle",
        description: "Our most popular package with advanced features",
        price: 199.99,
        image: "https://via.placeholder.com/300x200?text=Premium+Bundle",
        details: "Includes: Premium item X, Premium item Y, and Pro guide"
      },
      {
        id: 3,
        name: "Deluxe Bundle",
        description: "The ultimate package with all premium features",
        price: 299.99,
        image: "https://via.placeholder.com/300x200?text=Deluxe+Bundle",
        details: "Includes: Deluxe item Z, Deluxe item W, and Master guide"
      }
      // ... other bundles
    ]; */

    const selectedBundle = mockBundles.find(b => b.id === parseInt(id));
    setBundle(selectedBundle);
  }, [id]);

  const handleAddToCart = () => {
    if (!bundle) return;
    
    // Create a new cart object with the selected bundle
    const newCart = { 
      ...cart, 
      bundle: {
        id: bundle.id,
        name: bundle.name,
        price: bundle.price,
        image: bundle.image
      }
    };
    
    // Update the cart state
    updateCart(newCart);
    
    // Navigate to items page
    navigate('/items');
  };

  if (!bundle) return <div>Loading bundle...</div>;

  return (
    <div className="bundle-details-container">
      <h1>{bundle.name}</h1>
      <img src={bundle.image} alt={bundle.name} />
      <p>{bundle.description}</p>
      <p>Price: ${bundle.price.toFixed(2)}</p>
      <p>{bundle.details}</p>
      
      <button 
        onClick={handleAddToCart}
        className="add-to-cart-button"
      >
        Select This Bundle
      </button>
      
      <button 
        onClick={() => navigate('/bundles')}
        className="back-button"
      >
        Back to Bundles
      </button>
    </div>
  );
};

export default BundleDetailsPage;